import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  data: {
    business: null,
    sales: [],
    dates: [],
    totalSales: 0,
    histogramData: {
      labels: [],
      datasets: []
    },
    dateRange: {
      start: null,
      end: null,
      isDefault: false
    }
  },
  loading: false,
  error: null,
  filters: {
    startDate: null,
    endDate: null,
    frequency: "monthly",
    searchField: "",
    searchQuery: "",
    hideZeroSales: false
  }
};

const saleReportByPercentSlice = createSlice({
  name: "saleReportByPercent",
  initialState,
  reducers: {
    saleReportByPercentRequest(state, action) {
      state.loading = true;
      state.error = null;
      // Update filters if provided
      if (action.payload) {
        state.filters = { ...state.filters, ...action.payload };
      }
    },
    saleReportByPercentSuccess(state, action) {
      state.loading = false;
      state.data = action.payload.data;
      state.error = null;
    },
    saleReportByPercentFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
      state.data = initialState.data;
    },
    setSaleReportByPercentFilters(state, action) {
      state.filters = { ...state.filters, ...action.payload };
    },
    resetSaleReportByPercent(state) {
      state.loading = false;
      state.error = null;
      state.data = initialState.data;
      state.filters = initialState.filters;
    },
    clearSaleReportByPercentError(state) {
      state.error = null;
    }
  },
});

export const {
  saleReportByPercentRequest,
  saleReportByPercentSuccess,
  saleReportByPercentFailure,
  setSaleReportByPercentFilters,
  resetSaleReportByPercent,
  clearSaleReportByPercentError,
} = saleReportByPercentSlice.actions;

export default saleReportByPercentSlice.reducer;